"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ImageLightbox", {
  enumerable: true,
  get: function get() {
    return _ImageLightbox.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ImageLightbox.default;
  }
});

var _ImageLightbox = _interopRequireDefault(require("./ImageLightbox"));